import { DOMAIN_PATTERNS, type DOMAINS } from '~/domains/core';

export type CurrentDomain = keyof typeof DOMAINS;
const DEFAULT_DOMAIN: CurrentDomain = 'ASBIS';

export const getCurrentDomain = (hostname: string): CurrentDomain => {
  const availableDomains = Object.keys(DOMAIN_PATTERNS) as CurrentDomain[];
  const matchedDomain = availableDomains.find((domain) =>
    hostname.includes(DOMAIN_PATTERNS[domain]),
  );

  return matchedDomain ?? DEFAULT_DOMAIN;
};
